import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class GebaeudeklasseNutzungsart extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;
    gebaeudeklasse_id: number | null = null;
    nutzungsart_id: number | null = null;
    bemerkung: string | null = null;

    // view fields:
    gebaeudeklasse_i18n_key: string | null = null;
    gebaeudeklasse_code: number | null = null;
    gebaeudeklasse_bezeichnung: string | null = null;
    nutzungsart: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'GebaeudeklasseNutzungsart';
    }
}

export async function createNewUser(): Promise<GebaeudeklasseNutzungsart> {
    const gn = createModel(GebaeudeklasseNutzungsart, {});

    await gn.save();
    return gn;
}

export class GebaeudeklasseNutzungsartCollection extends BaseCollection<GebaeudeklasseNutzungsart> {
    protected modelCls = GebaeudeklasseNutzungsart;

    public getModelClassName(): string {
        return 'GebaeudeklasseNutzungsart';
    }
}
